import { Text, useColorModeValue } from '@chakra-ui/react';

import { ScoreValueBox } from '../../Common/ScoreValueBox';
import { profitRatingScoreBoxAppearance } from '../../../utils/profitRatingColors';

/** Numeric Profit Rating (PR) for marketing preview tables. */
export function PrTableCellLite({
  score,
  hideShortLabel = false,
  size = 'xs',
}: {
  score: number | null | undefined;
  hideShortLabel?: boolean;
  size?: 'xs' | 'sm' | 'md';
}) {
  const isDark = useColorModeValue(false, true);
  if (score == null || Number.isNaN(Number(score))) {
    return (
      <Text color="gray.500" fontSize="sm">
        —
      </Text>
    );
  }
  const appearance = profitRatingScoreBoxAppearance(Number(score), isDark);
  return (
    <ScoreValueBox
      family="profit"
      shortLabel="PR"
      value={Number(score)}
      size={size}
      appearance={appearance}
      compact
      hideShortLabel={hideShortLabel}
    />
  );
}
